const TOKEN_KEY = 'Authorization'

// 登录上下文键集（spec §10）：登录态/用户/校区上下文跨 tab 共享，统一存 localStorage。
// 偏好键（lastChoiceLocation/date/spec/journal_date）与草稿键（draft:*）及 recentEmoji
// 仍留 sessionStorage，不在迁移集内。
const LOGIN_KEYS = [
  TOKEN_KEY,
  'login',
  'userType',
  'userId',
  'userInfo',
  'isAdmin',
  'companyId',
  'schoolName',
  'className',
  'classId',
  'rolePermission',
  'location',
  'locationId'
]

// 读登录键：只认 localStorage（R49 clean-cut）——不做 sessionStorage 回落/回迁。
// 旧回落在登出后会把其它 tab 陈旧的 token 复活并回写共享 localStorage（登出失效+跨 tab 传染）；
// 现存 sessionStorage 旧会话不再迁移，登一次即可（spec §10 已接受）。
function readLogin(key) {
  return localStorage.getItem(key)
}

// App 挂载时绑定本 tab 的认证身份；其它 tab 改凭证不能替换本页面 DTO 的归属。
let boundSession = null
function currentSession() {
  return { token: readLogin(TOKEN_KEY), userId: readLogin('userId') }
}

function writeLogin(key, value) {
  localStorage.setItem(key, value)
  // 本 tab 显式登录可更新绑定；只更新所写字段，不能顺带接纳其它 tab 的凭证。
  if (boundSession && key === TOKEN_KEY) boundSession.token = String(value)
  if (boundSession && key === 'userId') boundSession.userId = String(value)
  // 顺手清同 tab 的旧 sessionStorage 副本（一次性清理，只出不进，不再回迁）
  sessionStorage.removeItem(key)
}

function removeLogin(key) {
  localStorage.removeItem(key)
  sessionStorage.removeItem(key)
}

// InsertEmoji.vue 以命名导入方式使用，需同时提供命名导出
export function getRecentEmoji() {
  return sessionStorage.getItem('recentEmoji')
}
export function setRecentEmoji(recentEmoji) {
  return sessionStorage.setItem('recentEmoji', recentEmoji)
}

export default {
  bindSession() {
    boundSession = currentSession()
  },
  getSessionIdentity() {
    return JSON.stringify(currentSession())
  },
  isSessionCurrent() {
    return !boundSession || JSON.stringify(boundSession) === JSON.stringify(currentSession())
  },
  getToken() {
    return readLogin(TOKEN_KEY)
  },
  setToken(token) {
    return writeLogin(TOKEN_KEY, token)
  },
  setRolePermission(rolePermission) {
    return writeLogin('rolePermission', JSON.stringify(rolePermission))
  },
  getRolePermission() {
    try {
      return JSON.parse(readLogin('rolePermission'))
    } catch (e) {
      return null
    }
  },
  // 只删登录集键（localStorage 登录键集，顺手清同 tab 旧 sessionStorage 副本），不碰偏好/草稿键：
  // 清 localStorage 登录键集即真正失效（登录态只认 localStorage，R49），
  // 整清 sessionStorage 既无法完成登出，还会误删 draft:* 草稿。
  removeToken() {
    LOGIN_KEYS.forEach(removeLogin)
    if (boundSession) boundSession = currentSession()
  },
  getLogin() {
    return readLogin('login')
  },
  setLogin(login) {
    return writeLogin('login', login)
  },
  getUserType() {
    return readLogin('userType')
  },
  setUserType(userType) {
    return writeLogin('userType', userType)
  },
  getUserId() {
    return readLogin('userId')
  },
  setUserId(userId) {
    return writeLogin('userId', userId)
  },
  setUserInfo(userInfo) {
    return writeLogin('userInfo', JSON.stringify(userInfo))
  },
  getUserInfo() {
    try {
      return JSON.parse(readLogin('userInfo'))
    } catch (e) {
      return null
    }
  },
  setIsAdmin(isAdmin) {
    return writeLogin('isAdmin', isAdmin)
  },
  getIsAdmin() {
    return readLogin('isAdmin')
  },
  setLocation(location) {
    return writeLogin('location', location)
  },
  getLocation() {
    return readLogin('location')
  },
  setLocationId(locationId) {
    return writeLogin('locationId', locationId)
  },
  getLocationId() {
    return readLogin('locationId')
  },
  setCompany(companyId) {
    return writeLogin('companyId', companyId)
  },
  getCompany() {
    return readLogin('companyId')
  },
  setSchoolName(schoolName) {
    return writeLogin('schoolName', schoolName)
  },
  getSchoolName() {
    return readLogin('schoolName')
  },
  setClassName(className) {
    return writeLogin('className', className)
  },
  getClassName() {
    return readLogin('className')
  },
  setClassId(classId) {
    return writeLogin('classId', classId)
  },
  getClassId() {
    return readLogin('classId')
  },
  getRecentEmoji,
  setRecentEmoji

  // setRolePermission(rolePermission) {
  //   return sessionStorage.setItem('rolePermission', rolePermission)
  // },
  // getRolePermission() {
  //   return sessionStorage.getItem('rolePermission')
  // },
  // getWorkType() {
  //   return sessionStorage.getItem('workType')
  // },
  // setWorkType(workType){
  //   return sessionStorage.setItem('workType', workType)
  // },
  // getJobTitle() {
  //   return sessionStorage.getItem('jobTitle')
  // },
  // setJobTitle(jobTitle){
  //   return sessionStorage.setItem('jobTitle', jobTitle)
  // },
  // getRoleList() {
  //   return sessionStorage.getItem('roleList')
  // },
  // setRoleList(roleList){
  //   return sessionStorage.setItem('roleList', roleList)
  // },
  // getLocationListList() {
  //   return sessionStorage.getItem('locationList')
  // },
  // setLocationListList(locationList){
  //   return sessionStorage.setItem('locationList', locationList)
  // },
}
